import { makeStyles, Theme, Typography } from '../../../index';
import React from 'react';
import NoResultsImage from './NoResultsImage.svg';
import { useTranslation } from '@fluentsms/i18n';

const useStyles = makeStyles((theme: Theme) => ({
  notFound: {
    textAlign: 'center',
    marginTop: theme.spacing(4),
  },
  photo: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

export const NoResults = (): JSX.Element => {
  const { t } = useTranslation('orders');
  const classes = useStyles();
  return (
    <div className={classes.notFound} data-testid={'NoResults-component'}>
      <Typography color="textPrimary" variant={'h4'} align="center">
        {t('fluentTransferList.noResults.title')}
      </Typography>
      <img className={classes.photo} src={NoResultsImage} alt="no-results-image" />
      <Typography color="textPrimary" variant={'body2'} align="center">
        {t('fluentTransferList.noResults.body')}
      </Typography>
    </div>
  );
};
